import { Box, CircularProgress, FormControl, FormHelperText, Input, InputAdornment, InputLabel, makeStyles, TextField, Typography } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { config } from '../utils/uploadImage'
import S3 from 'react-aws-s3'
import Loader from './Loader'
import { MdAttachFile } from 'react-icons/md'
import useValidation from '../hooks/Validation/useValidation'
import SimpleReactValidator from 'simple-react-validator'

const useStyles = makeStyles((theme) => ({
  input: {
    // width: '100%',
    // border: 'none',
    // color: theme.palette.common.black,
    // '&:focus': {
    //   outline: 'none',
    // },
    [theme.breakpoints.up('md')]: {
      width: '80%',
      // fontSize: '14px',
      // marginTop: '22px',
      fontSize: '16px',
      // padding: '8.5px',
    },
  },
  input2: {
    width: '100%',
    fontWeight: 'bold',
    color: theme.palette.common.black,
    [theme.breakpoints.up('md')]: {
      // width: '90%',
      fontSize: '14px',
      // marginTop: '5px',
      padding: '8.5px',
    },
  },
  error: {
    border: '1px solid red',
  },
  // label: { marginTop: '5px' },
}))

export default function CustomInput({
  className,
  handleChange,
  value,
  placeholder,
  type = 'text',
  fullWidth,
  errorMessage,
  onKeyDown,
  image,
  number,
  label,
  multiple,
  setForm,
  form,
  formCheck,
  name,
  single,
  onChange,
}) {
  // //console.log('NAME COMING : ', name)

  const classes = useStyles()
  const [progress, setProgress] = React.useState(false)
  const [tempName, setTempName] = React.useState('Browse')

  const handleOnChange = (event) => {
    if (event.target.value.charAt(0) === ' ') {
      return event.preventDefault()
    }
    handleChange(event.target.value)
  }
  const handleNumber = (event) => {
    const re = /^[0-9\b]+$/
    if (event.target.value === '' || re.test(event.target.value)) {
      setForm({ ...form, [event.target.name]: event.target.value })
    }
  }

  const handleChangeNew = (event) => {
    //console.log('Value : ', event.target.value)
    if (event.target.value.charAt(0) === ' ') {
      return event.preventDefault()
    }
    setForm({ ...form, [event.target.name]: event.target.value })
  }

  const handleFile = (e) => {
    setProgress(true)
    const ReactS3Client = new S3(config)
    console.log(e.target.files)
    console.log(e.target.id)
    setTempName(e.target.files[0].name)
    ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}-${e.target.files[0].name}`)
      .then((data) => {
        handleChange(data.location)
        console.log("location", data.location)
        setProgress(false)
      })
      .catch((err) => {
        //console.log(err)
        setProgress(false)
      })
  }

  const handleNewFile = (e) => {
    //console.log('NAME : ', e.target.name)
    setProgress(true)
    setTempName(e.target.files[0].name)
    const ReactS3Client = new S3(config)
    ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}${e.target.files[0].name}`)
      .then((data) => {
        setForm({ ...form, [e.target.name]: data.location })
        // handleChange(data.location)
        //console.log(data.location)
        setProgress(false)
      })
      .catch((err) => {
        //console.log(err)
        setProgress(false)
      })
  }

  const handleMultipleFile = (e) => {
    let arrImages = []
    //console.log('NAME : ', e.target.name)

    Object.keys(e.target.files).forEach((key) => {
      let img = e.target.files[key]
      setProgress(true)

      const ReactS3Client = new S3(config)
      ReactS3Client.uploadFile(img, `product-images/${Math.random()}${img.name}`)
        .then((data) => {
          setProgress(false)
          arrImages.push(data.location)
          // handleChange([...arrImages])
          setForm({ ...form, [e.target.name]: [...arrImages] })
          //console.log(arrImages)
        })
        .catch((err) => {
          setProgress(false)
        })
    })
  }

  return (
    <div className={classes.label}>
      {placeholder && <label htmlFor=""> {placeholder} </label>}
      {label === 'Description' || label === 'Remark *' ? (
        <textarea
          type={type}
          value={value}
          onChange={formCheck ? handleChangeNew : handleOnChange}
          placeholder={label || placeholder}
          onBlur={onKeyDown}
          className={'form-control'}
          style={{ width: '100%', height: '30px', marginTop: '33px' }}
          name={name}
        />
      ) : type === 'file' ? (
        <Box display="flex" flexDirection="column" style={{ marginTop: '22px' }}>
          <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{label}</Typography>
          {single ? (
            <>
              <input accept="image/*" style={{ display: 'none' }} id={`icon-button-file-${name}`} type="file" onChange={handleFile} name={name} />
            </>
          ) : (
            <>
              <input
                accept="image/*" 
                style={{ display: 'none' }}
                id="icon-button-file"
                type="file"
                onChange={multiple ? handleMultipleFile : handleNewFile}
                name={name}
                value={null}
                multiple={multiple ? true : false}
              />
            </>
          )}

          <label htmlFor={`icon-button-file-${name}`}>
            <FormControl className={className ? `${className} ${classes.input}` : classes.input} required>
              {/* <InputLabel>{label}</InputLabel> */}
              <Input
                startAdornment={
                  <InputAdornment position="start">
                    <MdAttachFile />
                  </InputAdornment>
                }
                disabled={true}
                value={tempName}
                fullWidth={true}
              />
            </FormControl>
          </label>
          {progress && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 'auto' }}>
              <CircularProgress style={{ width: '28px', height: '28px', margin: 'auto' }} />
            </div>
          )}
        </Box>
      ) : (
        <Box display="flex" justifyContent="space-between" flexDirection="column" style={{ marginTop: '22px' }}>
          <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{label}</Typography>
          <TextField
            type={number ? 'number' : type}
            value={type === 'file' ? null : value}
            onChange={
              // number
              //   ? handleNumber
              type === 'file' ? handleNewFile : multiple && type === 'file' ? handleMultipleFile : formCheck ? handleChangeNew : onChange ? onChange : handleOnChange
            }
            // label={label}
            onBlur={onKeyDown}
            className={className ? `${className} ${classes.input}` : classes.input}
            error={errorMessage ? true : false}
            helperText={errorMessage ? errorMessage : ''}
            multiple={type === 'file' ? true : false}
            name={name}
          />
        </Box>
      )}

      {/* <FormHelperText style={{ color: 'red' }}> {errorMessage ? errorMessage : ''}</FormHelperText> */}

      {/* {!errorMessage ? null : <ErrorMessage errorMessage={errorMessage} />} */}
    </div>
  )
}
